import { createSelector } from 'reselect';

const selectPolicyCollections = (state: any) => state.policyCollections;


export const selectPolicyCollectionCurrentItem = createSelector([selectPolicyCollections], (policyCollections) => policyCollections.current);

export const selectPolicyCollectionsListItems = createSelector([selectPolicyCollections], (policyCollections) => policyCollections.list);

export const selectPolicyCollectionItemById = (itemId: any) =>
    createSelector(selectPolicyCollectionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

// Dynamic selector based on keyState
export const selectPolicyCollectionByKey = (keyState: string) =>
    createSelector([selectPolicyCollections], (policyCollections) => {
        return policyCollections[keyState] || {}; // Return the data for the given keyState
    });


export const selectPolicyCollectionQueryItems = createSelector([selectPolicyCollections], (policyCollections) => policyCollections.query);

export const selectPolicyCollectionCreatedItem = createSelector([selectPolicyCollections], (policyCollections) => policyCollections.create);

export const selectPolicyCollectionUpdatedItem = createSelector([selectPolicyCollections], (policyCollections) => policyCollections.update);

export const selectPolicyCollectionReadItem = createSelector([selectPolicyCollections], (policyCollections) => policyCollections.read);

export const selectPolicyCollectionDeletedItem = createSelector([selectPolicyCollections], (policyCollections) => policyCollections.delete);

export const selectPolicyCollectionSearchedItems = createSelector([selectPolicyCollections], (policyCollections) => policyCollections.search);

export const selectPolicyCollectionItemsCount = createSelector([selectPolicyCollections], (policyCollections) => policyCollections.count);

export const selectPolicyCollectionItemsFilter = createSelector([selectPolicyCollections], (policyCollections) => policyCollections.filter);

export const selectPolicyCollectionsEntityListItems = createSelector([selectPolicyCollections], (policyCollections) => policyCollections.list);